<div class="tag-dropdown-container" (click)="stopPropagation($event)">
  <div class="search-container">
    <div class="search-input-wrapper remove-mat-form-field-wrapper">
      <mat-form-field class="search-tag-input-field">
        <input
          #searchInput
          matInput
          type="text"
          [(ngModel)]="searchText"
          (ngModelChange)="onSearchChange()"
          [placeholder]="'tags.searchTags' | translate"
          cdkFocusInitial
        />

        @if (searchText) {
          <button
            matSuffix
            tabindex="-1"
            type="button"
            mat-icon-button
            (click)="clearSearch($event)"
          >
            <mat-icon>clear</mat-icon>
          </button>
        }
      </mat-form-field>
      <button
        mat-icon-button
        class="settings-button"
        matTooltip="{{ 'global.tagSettings' | translate }}"
        (click)="openTagSettings($event)"
      >
        <mat-icon>settings</mat-icon>
      </button>
    </div>
  </div>

  @if (isLoadingTags) {
    <div class="progress-spinner-container">
      <mat-spinner class="progress-spinner" [diameter]="30"></mat-spinner>
    </div>
  } @else {
    <div class="tags-list">
      @if (filteredTags.length === 0) {
        <div class="no-results">
          <span>{{ 'tags.noTagsFound' | translate }}</span>
        </div>
      } @else {
        @for (tag of filteredTags; track tag.id) {
          <div class="tag-item" (click)="addTag(tag, $event)">
            <div
              class="tag-name"
              matTooltip="{{ tag.description }}"
              matTooltipPosition="right"
              [ngStyle]="{ color: tag.color }"
            >
              {{ tag.name }}
            </div>
          </div>
        }
      }
    </div>
  }
</div>
